(async () => {
    const { Core } = await importModule('Core');
    customElements.define('main-navigation-mobile', class extends Core {
        elements = { stage: '[data-stage]', navItems: '*[data-to-lvl]' };
        render() {
            const levels = Array.from(this.$stage.firstElementChild.children);
            levels.forEach((level, index) => { level.inert = index !== 0; level.setAttribute('aria-hidden', String(index !== 0)); });
            this.$navItems.forEach(item => {
                item.addEventListener('keydown', event => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        item.click();
                    }
                });
                item.addEventListener('click', () => {
                    const next = Number(item.dataset.toLvl);
                    this.$stage.dataset.current = String(next);
                    levels.forEach((level, index) => { level.inert = index !== next; level.setAttribute('aria-hidden', String(index !== next)); });
                    queueMicrotask(() => {
                        const target = Array.from(levels[next].querySelectorAll('a[href], [tabindex="0"], button, summary')).find(node => node.getClientRects().length);
                        target?.focus({ preventScroll: true });
                    });
                });
            });
        }
    });
})();
